module.exports = __webpack_public_path__ + "static/Kokos-58e00705086583959f819f6c1db1e880.png";